export default "__VITE_ASSET__9b1f561d__"